import { render, staticRenderFns } from "./NewspaperCitation.vue?vue&type=template&id=301b5da0&"
import script from "./NewspaperCitation.vue?vue&type=script&lang=js&"
export * from "./NewspaperCitation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports